export default __webpack_public_path__ + "static/media/index-bg.8dbf73e2.jpg";